const filterSlotTimetables = async (slotId, timeId, timetables) =>
  timetables.filter((timetable) => timetable.timeId === timeId && timetable.slotId === slotId)

export default filterSlotTimetables
